
import React from 'react';
import { FaBookOpen } from 'react-icons/fa'; 
import './HandbookHeroSection.css'; 

const HandbookHeroSection = () => {
  return (
    <section className="_hHSection_a1A_"> 
      <div className="_hHContent_b2B_"> 
        <div className="_hIWrap_c3C_"> 
          <FaBookOpen className="_hHIcon_d4D_" /> 
        </div>
        <h1 className="_hHTitle_e5E_"> 
          Vanidya Support Handbook
        </h1>
        <p className="_hHSubtitle_f6F_"> 
          For support volunteers and agents: how to deliver fast, friendly, and fair service across the Vanidya platform.
        </p>
      </div>
    </section>
  );
};

export default HandbookHeroSection;
